<template>
  <div class="general">
    <div class="heading">
      {{$ml.get(`General Settings`)}}
    </div>
    <div class="middle">
      <app-text-input
        :label="$ml.get('Full name')"
        :type="'text'"
        v-model="form.full"
      />
      <app-text-input
        :label="$ml.get(`Email`)"
        :type="'email'"
        v-model="form.email"
      />
      <app-text-input
        :label="$ml.get(`Phone`)"
        :type="'tel'"
        v-model="form.phone"
      />

      <div>
        <app-btn @click="save">
          {{ $ml.get(`save`) }}
        </app-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {
        email: '',
        phone: '',
        full: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      activeUser: 'subAccount/activeUser',
    })
  },
  created () {
    this.form = {
      email: this.activeUser.email,
      phone: this.activeUser.phone,
      full: this.activeUser.firstName
    }
  },
  methods: {
    save () {
      this.activeUser.email = this.form.email;
      this.activeUser.phone = this.form.phone;
      this.activeUser.firstName = this.form.full;

      this.$store.dispatch('subAccount/saveGeneral').then(res => {
        this.$notify({group: 'notices', title: this.$ml.get('Info was successfully updated!'), type: 'success'});
      }).catch(err => {
        this.$notify({group: 'notices', title: this.$ml.get('Info was not updated!'), type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.general {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 23px;

  @media (max-width: 640px) {
    align-items: center;
  }

  .heading {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 25px;
    color: #4C5056;
    margin-bottom: 15px;
    padding-left: 20px;
  }

  .middle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    >div {
      margin: 22px 20px;
      width: calc(50% - 40px);
      min-width: 250px;
    }
  }
}
</style>
